module.exports = __webpack_public_path__ + "img/82_19.8a0fe8e7.png";